import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M2.288 28.953a5 5 0 0 0 4.422 4.421q.628.07 1.29.13v3.45a3 3 0 0 0 5.103 2.139l5.224-5.135q.74.006 1.503.006 7.855 0 13.45-.603a5 5 0 0 0 4.434-4.425C37.905 27.193 38 24.884 38 22q0-4.065-.252-7.105a7 7 0 0 0-6.361-6.394A130.3 130.3 0 0 0 8.61 8.496a7 7 0 0 0-6.357 6.392Q2 17.93 2 22q0 4.338.288 6.953m6.793 2.638a1 1 0 0 1 .919.997v4.365a1 1 0 0 0 1.7.713l5.52-5.424a1 1 0 0 1 .712-.287q.93.01 1.898.01 7.756 0 13.236-.593a3 3 0 0 0 2.66-2.655q.273-2.49.274-6.717 0-3.988-.245-6.94a5 5 0 0 0-4.544-4.566 128.3 128.3 0 0 0-22.424-.006 5 5 0 0 0-4.541 4.566Q4 18.006 4 22q0 4.24.276 6.734a3 3 0 0 0 2.653 2.652q1.029.114 2.152.205M28 38l-3.2-.001c-3.104-.002-4.306-.002-5.798.001a1 1 0 1 1-.004-2c1.495-.003 2.698-.003 5.802-.001L28 36q1.063 0 2.098-.013a1 1 0 0 1 .714.287l5.487 5.392A1 1 0 0 0 38 40.953V36.59a1 1 0 0 1 .917-.997q1.127-.093 2.154-.207a3 3 0 0 0 2.653-2.652Q43.999 30.24 44 26q0-3.993-.246-6.946a5 5 0 0 0-3.16-4.242 1 1 0 1 1 .73-1.862 7 7 0 0 1 4.423 5.938Q46 21.93 46 26q0 4.338-.288 6.953a5 5 0 0 1-4.422 4.421q-.627.07-1.29.131v3.448a3 3 0 0 1-5.103 2.14l-5.19-5.102Q28.86 38 28 38",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "mask",
    {
      id: "Chat-Outlined_svg__a",
      width: 44,
      height: 36,
      x: 2,
      y: 8,
      "mask-type": "alpha",
      maskUnits: "userSpaceOnUse"
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M2.288 28.953a5 5 0 0 0 4.422 4.421q.628.07 1.29.13v3.45a3 3 0 0 0 5.103 2.139l5.224-5.135q.74.006 1.503.006 7.855 0 13.45-.603a5 5 0 0 0 4.434-4.425C37.905 27.193 38 24.884 38 22q0-4.065-.252-7.105a7 7 0 0 0-6.361-6.394A130.3 130.3 0 0 0 8.61 8.496a7 7 0 0 0-6.357 6.392Q2 17.93 2 22q0 4.338.288 6.953m6.793 2.638a1 1 0 0 1 .919.997v4.365a1 1 0 0 0 1.7.713l5.52-5.424a1 1 0 0 1 .712-.287q.93.01 1.898.01 7.756 0 13.236-.593a3 3 0 0 0 2.66-2.655q.273-2.49.274-6.717 0-3.988-.245-6.94a5 5 0 0 0-4.544-4.566 128.3 128.3 0 0 0-22.424-.006 5 5 0 0 0-4.541 4.566Q4 18.006 4 22q0 4.24.276 6.734a3 3 0 0 0 2.653 2.652q1.029.114 2.152.205M28 38l-3.2-.001c-3.104-.002-4.306-.002-5.798.001a1 1 0 1 1-.004-2c1.495-.003 2.698-.003 5.802-.001L28 36q1.063 0 2.098-.013a1 1 0 0 1 .714.287l5.487 5.392A1 1 0 0 0 38 40.953V36.59a1 1 0 0 1 .917-.997q1.127-.093 2.154-.207a3 3 0 0 0 2.653-2.652Q43.999 30.24 44 26q0-3.993-.246-6.946a5 5 0 0 0-3.16-4.242 1 1 0 1 1 .73-1.862 7 7 0 0 1 4.423 5.938Q46 21.93 46 26q0 4.338-.288 6.953a5 5 0 0 1-4.422 4.421q-.627.07-1.29.131v3.448a3 3 0 0 1-5.103 2.14l-5.19-5.102Q28.86 38 28 38",
        clipRule: "evenodd"
      }
    )
  ),
  /* @__PURE__ */ React.createElement("g", { mask: "url(#Chat-Outlined_svg__a)" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M0 0h48v48H0z" }))
);
var SvgChatOutlined = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ChatOutlined_default = SvgChatOutlined;

export { ChatOutlined_default as default };
